__turbopack_context__.v({
  "blok-big-title": "InlineContent-module__aT_Asq__blok-big-title",
  "blok-subtitle": "InlineContent-module__aT_Asq__blok-subtitle",
  "blok-title": "InlineContent-module__aT_Asq__blok-title",
  "direction-column": "InlineContent-module__aT_Asq__direction-column",
  "product-card__inline": "InlineContent-module__aT_Asq__product-card__inline",
});
